import { TransactionsTranslations } from "../../../pt-BR/place/transactions";

export const TRANSACTIONS_FR_FR: TransactionsTranslations = {
	title: "Transactions",
	titleForeign: "Produits",
	activeTab: "transactions",
	valueTransactioned: "Valeur Transacionnée",
	value: "Valeur Brute Émise",
	netValue: "Valeur Nette Émise",
	period: "Période",
	export: "Exporter Excel",
	filterIssued: "Émis",
	filterIssuedLabel: "Filtrer par statut",
	filterNotIssued: "Non émis",
	descriptionForeign:
		"Dans ce rapport, il est possible d'avoir une vue de la facturation fiscale émise en considérant chaque produit transacionné, avec la possibilité de filtrer par période et statut. La valeur brute émise inclut la Taxe sur la Valeur Ajoutée (TVA), tandis que la valeur nette émise est calculée après déduction de la TVA.",
	columns: {
		transactionId: "Id de la Transaction",
		productName: "Produit",
		count: "Qté",
		value: "Valeur unitaire",
		total: "Valeur totale",
		netValue: "Valeur Nette",
		discountValue: "Remise",
		tipValue: "Valeur du service",
		date: "Date",
		isCombo: "Combo",
		eventName: "Événement",
		eventDate: "Date événement",
		cnpj: "CNPJ Émetteur",
		cpf: "CPF Client",
		type: "Type",
		issuerNIF: "NIF Commerçant",
		recipientNIF: "NIF Client",
		invoiceSeries: "Série facture",
		invoiceNumber: "Nº facture",
		invoiceValue: "Valeur facture",
		invoiceNetValue: "Valeur facture nette",
		invoiceDate: "Date d'Émission",
	},
	sheet: {
		title: "Transactions",
		titleForeign: "Produits",
		filename: "transactions",
		filenameForeign: "produits",
		columns: {
			transactionId: "Id de la Transaction",
			productName: "Produit",
			count: "Quantité",
			value: "Valeur unitaire",
			productTotalValue: "Valeur totale du produit",
			total: "Valeur totale",
			netValue: "Valeur Nette",
			discountValue: "Remise",
			tipValue: "Valeur du service",
			date: "Date",
			isCombo: "C'est un Combo",
			eventName: "Événement",
			eventDate: "Date événement",
			cnpj: "CNPJ Émetteur",
			cpf: "CPF Client",
			type: "Type",
			issuerNIF: "NIF Commerçant",
			recipientNIF: "NIF Client",
			invoiceSeries: "Série facture",
			invoiceNumber: "Nº facture",
			invoiceValue: "Valeur facture",
			invoiceNetValue: "Valeur facture nette",
			invoiceDate: "Date d'Émission",
		},
	},
};
